var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    [
      _c("validation-observer", {
        ref: "validator",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var valid = ref.valid
              return [
                _vm.show
                  ? _c(
                      "b-form",
                      {
                        class: [_vm.inline ? "gap-2 items-center" : ""],
                        attrs: { inline: _vm.inline },
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.onSubmit($event)
                          },
                          reset: [
                            function($event) {
                              $event.preventDefault()
                              return _vm.clear($event)
                            },
                            _vm.onReset
                          ]
                        }
                      },
                      [
                        _c("validation-provider", {
                          staticClass: "flex-grow",
                          attrs: {
                            name: _vm.$t("knowledge_item_title"),
                            rules: "required",
                            slim: ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(validationContext) {
                                  return [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "input-group-1",
                                          label: _vm.$t("knowledge_item_title"),
                                          "label-for": "knowledge_item_title"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticClass: "required",
                                          attrs: {
                                            id: "knowledge_item_title",
                                            placeholder: _vm.$t(
                                              "knowledge_item_subject"
                                            )
                                          },
                                          model: {
                                            value: _vm.item.title,
                                            callback: function($$v) {
                                              _vm.$set(_vm.item, "title", $$v)
                                            },
                                            expression: "item.title"
                                          }
                                        }),
                                        _c(
                                          "b-form-invalid-feedback",
                                          { class: [{ absolute: _vm.inline }] },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  validationContext.errors[0]
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _c("validation-provider", {
                          staticClass: "flex-grow",
                          attrs: {
                            name: _vm.$t("knowledge_item_category"),
                            rules: "required",
                            slim: ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(validationContext) {
                                  return [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "input-group-3",
                                          label: _vm.$t(
                                            "knowledge_item_category"
                                          ),
                                          "label-for": "knowledge_item_category"
                                        }
                                      },
                                      [
                                        _c("b-form-select", {
                                          staticClass: "required-select",
                                          attrs: {
                                            id: "knowledge-item-category",
                                            options: _vm.knowledgeCategories,
                                            "text-field": "name",
                                            "value-field": "id"
                                          },
                                          model: {
                                            value:
                                              _vm.item.knowledge_category_id,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.item,
                                                "knowledge_category_id",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.knowledge_category_id"
                                          }
                                        }),
                                        _c(
                                          "b-form-invalid-feedback",
                                          { class: [{ absolute: _vm.inline }] },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  validationContext.errors[0]
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _c("validation-provider", {
                          staticClass: "flex-grow",
                          attrs: {
                            name: _vm.$t("knowledge_item_description"),
                            rules: "min:10",
                            slim: ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(validationContext) {
                                  return [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "input-group-2",
                                          label: _vm.$t(
                                            "knowledge_item_description"
                                          ),
                                          "label-for":
                                            "knowledge_item_description"
                                        }
                                      },
                                      [
                                        _c("simple-editor", {
                                          staticClass: "mb-2",
                                          model: {
                                            value: _vm.item.description,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.item,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression: "item.description"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _c(
                          "div",
                          { staticClass: "flex flex-row justify-end gap-4" },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  type: "submit",
                                  variant: "primary",
                                  disabled: !valid
                                }
                              },
                              [_vm._v("Salvar")]
                            ),
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "outline-secondary" },
                                on: { click: _vm.goBack }
                              },
                              [_vm._v("Voltar")]
                            )
                          ],
                          1
                        ),
                        _vm.isEdit()
                          ? _c(
                              "b-row",
                              { staticClass: "m-0" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { lg: "12" } },
                                  [
                                    _c("h5", { staticClass: "mt-2 mb-0" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("knowledge_subtitle_document")
                                        )
                                      )
                                    ]),
                                    _c("vs-divider")
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isEdit()
                          ? _c(
                              "b-row",
                              { staticClass: "pt-2 pb-2" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { lg: "12", md: "12" } },
                                  [
                                    _c(
                                      "vue-dropzone",
                                      {
                                        ref: "fileUploadZone",
                                        attrs: {
                                          id: "upload",
                                          "use-font-awesome": true,
                                          options: _vm.dropzoneOptions,
                                          "use-custom-dropzone-options": true,
                                          useCustomSlot: true
                                        },
                                        on: {
                                          "vdropzone-processing":
                                            _vm.dropzoneChangeUrl,
                                          "vdropzone-success":
                                            _vm.successSendFile,
                                          "vdropzone-error": _vm.error,
                                          "vdropzone-file-added": [
                                            _vm.added,
                                            _vm.fileAdded
                                          ],
                                          "vdropzone-queue-complete":
                                            _vm.complete
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dropzone-custom-content"
                                          },
                                          [
                                            _vm._v(
                                              " Arraste e solte para enviar um arquivo "
                                            ),
                                            _c(
                                              "p",
                                              { staticClass: "separator" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "separator-span"
                                                  },
                                                  [_vm._v(" ou ")]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "btn waves-effect outline-primary",
                                                attrs: {
                                                  type: "button",
                                                  variant: "outline-secondary"
                                                }
                                              },
                                              [_vm._v("Selecionar")]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isEdit()
                          ? _c(
                              "b-row",
                              { staticClass: "pt-2" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { md: "12" } },
                                  [
                                    _c("media-list", {
                                      attrs: {
                                        medias: _vm.files,
                                        "show-delete": true,
                                        "action-on-click": false
                                      },
                                      on: { deleteMedia: _vm.deleteMedia }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }